import { useTimeStore } from '@store/common/useTimeStore.js'
import dayjs from 'dayjs'

// 현재 시간 기준으로 가장 최근 5분 기준 시간 반환
export const getBaseTime5Min = (date = useTimeStore.getState().getBaseTime()) => {
  const d = new Date(date)
  d.setSeconds(0)
  d.setMilliseconds(0)
  const min = d.getMinutes()
  // 분을 5로 나눈 나머지만큼 뺀 값
  d.setMinutes(min - (min % 5))
  return d
}

export const getIsExactTime = (now, period) => {
  const d = dayjs(now)
  const h = d.hour()
  const m = d.minute()
  const s = d.second()
  const D = d.date()

  // 시간은 항상 9시 기준 - 뒤에 숫자로 분 조절 가능

  const [baseTime9, minOffsetStr] = period.split('-')

  if (minOffsetStr?.endsWith('s')) {
    const targetSecond = Number(minOffsetStr.replace('s', ''))

    if (baseTime9.endsWith('m')) {
      const targetMinute = Number(baseTime9.replace('m', ''))

      return m % targetMinute === 0 && s === targetSecond
    }

    if (baseTime9.endsWith('h')) {
      const targetHour = Number(baseTime9.replace('h', ''))

      return h % targetHour === 0 && m === 0 && s === targetSecond
    }

    if (baseTime9 === '1d') {
      return h === 9 && m === 0 && s === targetSecond
    }

    if (baseTime9 === '1w') {
      return d.day() === 1 && h === 9 && m === 0 && s === targetSecond
    }
  }

  const minOffset = Number(minOffsetStr || '1') // default 1

  const isTargetTime = h === 9 && m === minOffset && s === 10

  switch (baseTime9) {
    case '5s':
      return s % 5 === 0
    case '1m':
      return s === 10
    case '1h':
      return m === 0 && s === 10
    case '1d':
      return isTargetTime
    case '1w':
      // d.day() === 1 : 월요일 체크
      return d.day() === 1 && isTargetTime
    case '1mo':
      return D === 1 && isTargetTime
    default:
      return m % 5 === 0 && s === 10
  }
}
